import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1440,1080 C1440,1124.16 1404.16,1160 1360,1160 C1315.84,1160 1280,1124.16 1280,1080 C1280,1035.84 1315.84,1000 1360,1000 C1404.16,1000 1440,1035.84 1440,1080 L1440,1080 Z M560,520 L400,520 L400,40 L1520,40 L1520,520 L1360,520 L1360,200 L560,200 L560,520 Z M1600,1400 L1520,1400 L1520,1240 L400,1240 L400,1400 L320,1400 L320,840 C320,795.84 355.92,760 400,760 L400,920 L1520,920 L1520,760 C1564.08,760 1600,795.84 1600,840 L1600,1400 Z M560,1720 L1360,1720 L1360,1400 L560,1400 L560,1720 Z M1520,600 L1360,600 L1360,760 L560,760 L560,600 L400,600 C267.68,600 160,707.68 160,840 L160,1560 L400,1560 L400,1880 L1520,1880 L1520,1560 L1760,1560 L1760,840 C1760,707.68 1652.32,600 1520,600 L1520,600 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconPrinterLine = /*#__PURE__*/function (_Component) {
  _inherits(IconPrinterLine, _Component);

  var _super = _createSuper(IconPrinterLine);

  function IconPrinterLine() {
    _classCallCheck(this, IconPrinterLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconPrinterLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconPrinter",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconPrinterLine.displayName = "IconPrinterLine";
  return IconPrinterLine;
}(Component);

IconPrinterLine.glyphName = 'printer';
IconPrinterLine.variant = 'Line';
IconPrinterLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconPrinterLine;
export { IconPrinterLine };